module.exports = __webpack_public_path__ + "img/MOS Green.ac96c251.svg";